module.exports = __webpack_public_path__ + "static/media/software.9affbeb4.png";